import styled from '@emotion/styled'
import { css } from 'emotion'
import { ActionCard } from 'portal-modules/common/components/cards'
import { NavLink } from 'react-router-dom'
import { StyledIconButton } from 'portal-modules/common/components/cards/atoms'
import {
  Print,
  Download,
  ArrowDownSm,
  Filter,
} from '@entrata/portals-common/lib/icons'
import Button from 'portal-modules/common/components/Button'
import { quint } from '@entrata/portals-common/lib/styled-utils'
import { Accordion } from '@entrata/portals-common/lib/components'
import { RoundedCheckBox } from 'portal-modules/common/components/checkbox'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import { Form } from '@entrata/portals-common/lib/components/forms'
import PageHeader from 'portal-modules/common/components/page-shell/PageHeader'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
import { underlineFocus } from 'portal-modules/common/components/focus-styles'
import { StyledContent } from 'portal-modules/common/components/modals/rp-modal'
const { isNotRP } = getProjectConditions()

export const hideSelectInput = css`
  display: none;
`
export const StyledReason = styled('span')`
  font-style: italic;
  font-size: 12px;
  color: ${({ disableFlexPaymentAccount = false, theme }) =>
    disableFlexPaymentAccount ? theme.green.base : theme.error.base};
  margin-top: 14px;
  position: relative;
`

export const StyledAutoPaymentActionCard = styled(ActionCard)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
  background: ${({ disabled, theme }) =>
    getEmbeddedViewFlag()
      ? theme.embedded.foreground_color
      : disabled
        ? theme.mode.card_disabled_background
        : theme.mode.card_background_color};
  width: 100%;
  padding: 16px 16px 24px 16px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  height: 100%;

  header {
    display: flex;
    align-items: center;
    gap: 16px;
    align-self: stretch;
  }
`

export const StyeldCancelPaymentFooterDiv = styled('div')`
  background-color: ${({ theme }) => theme.gray.highlight};
  width: 100%;
  padding: 32px 32px 39px 32px;
  height: 125px;
  @media screen and (min-width: 768px) {
    height: 100px;
    padding: 32px 64px 39px 64px;
    position: fixed;
    bottom: 0;
  }
  @media screen and (max-width: 376px) {
    height: 200px;
    margin-top: 50px;
    padding: 30px 30px 20px 30px;
  }
`

export const StyledFooterText = styled('div')`
  color: ${({ theme }) => theme.gray.dark};
  font-size: 11px;
  font-style: italic;
`

export const StyledCancelPaymentLink = styled('div')`
  color: ${({ theme }) => theme.icon.base};
  font-size: 13px;
  margin: 17px 0 0 0;
  cursor: pointer;
  width: 114px;
`

export const StyledCancelFooterHeader = styled('h5')`
  margin: -10px 0 10px;
  text-transform: none;
  @media screen and (min-width: 768px) {
    margin: -25px 0 5px;
  }
`

export const StyledTabSlider = styled('ul')`
  height: 30px;
  width: fit-content;
  border-radius: 100px;
  padding: 2px;
  position: relative;
  width: fit-content;
  background-color: ${({ theme }) => theme.tabSlider.background};
  display: flex;
  flex-direction: row;
  list-style: none;
  border: 1px solid ${({ theme }) => theme.tabSlider.border_color};
  box-shadow: inset 1px 1px 4px rgba(0, 0, 0, 0.15);
  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`

export const StyledTabSliderLi = styled('li')`
  margin-top: 1px;
  width: max-content;
`

export const StyledNavSliderLink = styled(NavLink)`
  color: ${({ theme }) => theme.tabSlider.inactive_color};
  text-decoration: none;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  padding: 5px 16px;
  &.active {
    background: ${({ theme }) => theme.tabSlider.active_background};
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 100px;
    color: ${({ theme }) => theme.tabSlider.active_color};
    font-weight: 700 !important;
  }

  ::before {
    ${({ hasActiveDot, theme }) =>
      hasActiveDot &&
      `
        content: '.';
        color: ${theme.system_red.color};
        font-weight: bold;
        font-size: xx-large;
        position: absolute;
        margin: -17px 0 0 -12px;
    `}
  }
`

export const StyledBellWrapper = styled('a')`
  margin-right: 24px;
  margin-top: 4px;
  color: ${({ theme }) =>
    isNotRP ? theme.white.base : theme.gray.mediumlight};
`
export const StyledNotificationIndicator = styled('span')`
  width: ${({ width }) => width};
  height: 16px;
  align-items: center;
  background-color: #ff3b30;
  border-radius: ${({ borderRadius }) => borderRadius};
  color: ${({ theme }) => theme.text.white};
  display: inline-flex;
  font-size: 10px;
  font-weight: 400;
  justify-content: center;
  position: absolute;
  margin-left: 10px;
  padding: 4px;
  margin-top: -5px;
  text-align: center;
`
export const StyledReskinNavBarUserBtnDiv = styled('div')`
  position: absolute;
  right: ${({ isPanelVisible }) => (isPanelVisible ? '386px' : '0')};
  transition:
    position 0.6s ease,
    right 0.5s ease;

  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 24px;
`
export const StyledReskinNavBarUserBtnSettingLink = styled(NavLink)`
  color: ${({ theme }) => theme.gray.mediumlight};
  margin-top: 3px;
  margin-right: 10px;
`

export const StyledWrapperUL = styled('ul')`
  color: ${({ theme }) => theme.text.dark};
  list-style-type: none;
  margin: 0;
  padding: 0;
`

export const StyledLoaderDiv = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LeftSide = styled('td')`
  float: left;
  width: '50%';
`

export const RightSide = styled('td')`
  float: right;
  width: '50%';
`
export const StyledTable = styled('table')`
  width: 100%;
  @media only screen and (min-width: 768px) {
    margin-bottom: 10px;
  }
`

export const StyledPrint = styled(Print)`
  width: 12px;
  height: 12px;
`

export const StyledDownload = styled(Download)`
  width: 12px;
  height: 12px;
`

export const StyledAnchor = StyledIconButton.withComponent('a')

export const StyledPdfView = styled('div')`
  max-height: 480px;
  overflow-y: auto;
  border: 1px solid #d8dce0;
  box-sizing: border-box;
`
export const StyledPrintDownloadButton = styled(Button)`
  padding: 0;
  margin-right: 0;
`

export const StyledFooterWrapper = styled('div')`
  display: flex;
  justify-content: center;
`

export const StyledLoginCustomText = styled('p')`
  color: ${({ theme }) => theme.gray.mediumlight};
  font-size: 11px;
  margin: -7px 0 16px;
`
export const StyledCookiesNoticeContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: ${({ isLargeScreen }) => (isLargeScreen ? 'row' : 'column')};
  align-items: center;
`
export const StyledCookiesNoticeText = styled('p')`
  ${({ isLargeScreen }) =>
    isLargeScreen
      ? {
          width: '1248px',
          marginRight: '42px',
          fontSize: '14px',
        }
      : {
          width: '100%',
          marginRight: '0',
          fontSize: '10px',
        }};
  font-weight: 400;
`
export const StyledCookiesNoticePrivacyActionWrapper = styled('div')`
  ${({ isLargeScreen }) =>
    !isLargeScreen && {
      width: '100%',
      marginLeft: '60px',
      justifyContent: 'center',
      paddingBottom: '10px',
      marginTop: '10px',
    }};
  display: flex;
  flex-direction: row;
  gap: 15px;
`
export const StyledCookiesNoticeButtonWrapper = styled('div')`
  button {
    margin: 0;
    @media only screen and (max-width: 500px) {
      ${({ isLargeScreen }) =>
        !isLargeScreen && {
          width: 'max-content',
        }};
    }
  }
`
export const StyledCookiesNoticePreferences = styled('u')`
  margin: auto 15px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  width: ${({ isLargeScreen }) => (isLargeScreen ? '150px' : 'none')};
`
export const StyledCookiesNoticePrivacyText = styled('u')`
  cursor: pointer;
`
export const StyledCookiesModalContentsPrivacyLink = styled('span')`
  cursor: pointer;
  color: ${({ theme }) => theme.text.sidebar_accent};
`
export const StyledCookiesModalContentsText = styled('p')`
  color: ${({ theme }) => theme.text.sidebar_accent};
  text-align: justify;
  font-weight: 400;
  font-size: 13px;
`
export const StyledCookiesModalContentsDeniedButtonDiv = styled('div')`
  display: flex;
  justify-content: flex-end;

  button {
    border: none;
    margin-right: 1px;
  }
`
export const StyledCookiesModalContentsAccordianItemWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border-bottom: ${({ theme }) => `1px solid ${theme.gray.light}`};
  &#content-wrapper-1 {
    padding-bottom: 10px;
  }
  &.content-wrapper {
    padding-top: 10px;
  }
`
export const StyledCookiesModalContentsAccordianTitle = styled('span')`
  margin-left: 10px;
  font-weight: 400;
  font-size: 16px;
  color: ${({ theme }) => theme.text.sidebar_accent};
`

export const StyledCookiesModalContentsAccordianArrowDownSm = styled(
  ArrowDownSm,
)`
  transform: rotate(${({ rotation }) => rotation + 'deg'});
  transition: transform 200ms ${quint.easeOut};
  color: ${({ theme }) => theme.text.sidebar_accent};
`
export const StyledCookiesModalContentsCheckBoxWrapper = styled('span')`
  margin-left: auto;
  margin-right: 0;
`
export const StyledCookiesModalContentsRequireSpan = styled('span')`
  font-weight: 400;
  font-size: 14px;
  font-style: italic;
  margin-right: 5px;
  color: ${({ theme }) => theme.text.sidebar_accent};
`
export const StyledCookiesModalContentsAccordionDiv = styled('div')`
  margin-top: 20px;
  border-top: ${({ theme }) => `1px solid ${theme.gray.light}`};
`
export const StyledCookiesModalAccordionContents = styled(Accordion.Content)`
  overflow-y: auto;
  max-height: 300px;
  height: auto;
`
export const StyledCookiesModalAccordionContentsDesc = styled('p')`
  font-weight: 400;
  font-size: 13px;
  color: ${({ theme }) => theme.text.sidebar_accent};
  margin: ${({ is_editable }) =>
    is_editable ? '0 35px 24px 35px' : '20px 35px 24px 35px'};
  text-align: justify;
  &.content-description-1 {
    padding-top: 20px;
  }
`
export const StyledCookiesModalAccordionContentBox = styled('div')`
  width: 422px;
  border: ${({ theme }) => `1px solid ${theme.gray.light}`};
  border-radius: ${({ theme }) => theme.mode.card_border_radius };
  margin: 8px 4px 0 35px;
  padding: 12px;
  min-height: 80px;
  div {
    display: flex;
    flex-direction: row;
  }
  span {
    font-weight: 700;
    font-size: 12px;
    color: ${({ theme }) => theme.text.sidebar_accent};
    width: 59px;
    height: 16px;
    text-align: right;
  }
  p {
    margin: 0 0 8px 8px;
    text-align: justify;
    font-weight: 400;
    font-size: 12px;
    color: ${({ theme }) => theme.text.sidebar_accent};
  }
`
export const StyledCookiesModalAccordionContentBoxPurposeSpan = styled('span')`
  margin-left: 4px;
`
export const StyledCookiesModalAccordionContentBoxWrapper = styled('div')`
  display: flex;
`
export const StyledCookiesModalAccordionContentBoxCheckboxSpan = styled('span')`
  margin-top: 7px;
`
export const StyledCookiesModalRoundedCheckBox = styled(RoundedCheckBox)`
  div:first-child {
    svg {
      position: relative;
      top: ${({ isIndeterminate }) => (isIndeterminate ? '2px' : '1px')};
      height: ${({ isIndeterminate }) => (isIndeterminate ? '13px' : '12px')};
    }
  }
`
export const StyledContentsFeedHeaderBar = styled('div')`
  padding: 0;
  width: 100%;
  margin: 0;
`

export const StyledButtonFeedHeaderBar = styled('div')`
  position: relative;
  height: 35px;
  width: 40px;
  border: 1px solid ${({ theme }) => theme.gray.light};
  border-radius: 50%;
  margin: 9px 10px 0 5px;
  @media only screen and (max-width: 500px) {
    margin-top: 17px;
  }
`

export const StyledSpanFeedHeaderBar = styled('span')`
  color: ${({ theme }) => theme.gray.gray5};
  box-sizing: border-box;
  cursor: pointer;
`
export const StyledNavSpanFeedHeaderBar = styled('span')`
  cursor: pointer;
`
export const StyledFilteredSpanTextFeedHeaderBar = styled('span')`
  height: 17px;
  width: 81px;
  color: ${({ theme }) => theme.gray.dark};
  font-family: Inter;
  font-size: 10px;
  font-style: italic;
  letter-spacing: 0.19px;
  line-height: 1.8;
  @media only screen and (max-width: 767px) {
    margin-right: 0;
  }
`

export const StyledSpanTextFeedHeaderBar = styled('span')`
  height: 14px;
  width: 68px;
  color: ${({ theme }) => theme.blue.system_blue};
  font-family: Inter;
  font-size: 11px;
  letter-spacing: 0.25px;
  line-height: 1.9;
  text-align: center;
  cursor: pointer;

  @media only screen and (max-width: 767px) {
    font-size: 11px;
  }
`
export const StyledDivFeedHeaderBar = styled('div')`
  display: flex;
  justify-content: space-between;
  margin: ${({ customMargin }) => customMargin || ' 0 40px'};
  padding: 16px 0px;
  @media only screen and (max-width: 1024px) {
    margin: 0;
  }
  @media only screen and (max-width: 767px) {
    flex-direction: inherit;
    margin: 0;
    padding: 8px 16px;
  }
`

export const StyledFilteredBarFeedHeaderBar = styled('div')`
  margin: 0 40px;
  @media only screen and (max-width: 767px) {
    padding: 0 0 8px 0;
  }
  @media only screen and (max-width: 500px) {
    margin: 0;
  }
`
export const StyledFilteredBarContentFeedHeaderBar = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 34px;
  padding: 8px;
  background-color: rgba(216, 220, 224, 0.5);
  @media only screen and (max-width: 500px) {
    padding: 8px 16px;
  }
`
export const StyledFilterIcon = styled(Filter)`
  position: absolute;
  top: 30%;
  left: 30%;
`

export const StyledMobileTypeField = styled.div`
  .mobile-type-field+div>: first-child {
    color: ${({ theme }) => theme.blue.system_blue};
  }

  .mobile-type-field + div div {
    background-color: ${({ theme }) => theme.gray.gray5};
    border-radius: 16px;
  }

  .mobile-type-field + div button[aria-selected='true'] {
    background-color: ${({ theme }) => theme.gray.gray3};
    border-radius: 12px;
  }

  .mobile-type-field + div div:after {
    border-left: 10px solid ${({ theme }) => theme.gray.gray5};
  }
`

export const StyledInternationalPhoneField = styled.div`
  button {
    color: ${({ theme }) => theme.blue.system_blue};
  }

  div[role='listbox'] {
    background-color: ${({ theme }) => theme.gray.gray5};
    border-radius: 16px;
  }

  div:after {
    border-left: 10px solid ${({ theme }) => theme.gray.gray5};
  }

  div button[aria-selected='true'] {
    background-color: ${({ theme }) => theme.gray.gray3};
    border-radius: 12px;
    color: ${({ theme }) => theme.white.base};
  }

  div button[aria-selected='false'] {
    color: ${({ theme }) => theme.white.base};
  }
`

export const SubForm = styled(Form)`
  margin-bottom: 8px;
`
export const StyledFooterContent = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: -20px;
  align-items: flex-start;
  justify-content: space-between;
`
export const StyledTextSpan = styled('span')`
  font-size: 11px;
  margin-top: 11px;
  cursor: pointer;
  color: ${({ theme }) => theme.blue.system_blue};
`
export const StyledLabel = styled('span')`
  font-size: 14px;
`
export const StyledDiv = styled('div')`
  margin-top: 7px;
`

export const StyledReskinPageHeader = styled(PageHeader)`
  display: flex;
  flex-direction: column;

  min-height: 100px;
  margin: ${({ margin }) => !!margin && margin};

  h1 {
    margin-top: 15px;
    font-weight: 700;
    font-size: 32px;
    color: ${({ theme }) => theme.gray.gray5};
  }

  button {
    margin-top: 15px;
  }

  @media only screen and (max-width: 678px) {
    padding: ${({ mediaPadding }) => mediaPadding || '8px 0'};

    h1 {
      font-size: 21px;
    }
  }

  @media only screen and (min-width: 768px) {
    padding-bottom: 24px;
    padding-left: 0;
    position: relative;

    ul {
      bottom: 0;
      position: absolute;
    }
  }
`

export const StyledReskinPageHeaderWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  flex-wrap: wrap;
  @media only screen and (max-width: 500px) {
    margin-bottom: 0;
  }
  padding-right: 32px;
`
export const StyledTabSliderWrapper = styled('div')`
  margin-left: 8px;
`
export const StyledReskinCardWrapper = styled('div')`
  height: ${({ isHeightFixed, customHeight }) =>
    isHeightFixed ? '415px' : customHeight};
  width: ${({ customWebWidth }) => customWebWidth || '343px'};
  background: ${({ theme }) => theme.mode.card_background_color};
  box-shadow: ${({ theme }) => theme.mode.card_shadow};
  border-radius: ${({ theme }) => theme.mode.card_border_radius};
  position: relative;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-left: ${({ fromClubs }) => fromClubs && '10px'};
  }
  &:last-child {
    margin-right: ${({ fromClubs }) => fromClubs && '10px'};
  }
  @media only screen and (max-width: 768px) {
    height: ${({ fromHome, customMediaHeight }) =>
      !fromHome ? 'fit-content' : customMediaHeight};
    width: ${({ fromHome, customMediaWidth }) =>
      !fromHome ? '100%' : customMediaWidth};
    margin-top: ${({ fromClubs }) => fromClubs && '10px'};
  }
`
export const StyledReskinImage = styled('div')`
  height: ${({ fromHome }) => (fromHome ? '120px' : '144px')};
  background-image: ${({ image_url }) => `url(${image_url})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-color: ${({ theme }) => theme.gray.gray2};
  background-position: center;
  border-radius: 16px 16px 0 0;
  @media only screen and (max-width: 769px) {
    height: ${({ fromHome }) => !fromHome && '144px'};
  }
`
export const StyledReskinHeader = styled('div')`
  font-weight: 700;
  font-size: ${({ fromHome }) => (fromHome ? '13px' : '16px')};

  line-height: 1.4em;
  display: flex;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: ${({ theme }) => theme.gray.gray5};

  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin: ${({ customMargin }) => !!customMargin && customMargin};
  @media only screen and (max-width: 769px) {
    font-size: 16px;
  }
`
export const StyledReskinPricing = styled('div')`
  color: ${({ theme }) => theme.gray.mediumlight};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
`

export const StyledReskinContentHeading = styled('div')`
  color: ${({ theme }) => theme.gray.mediumlight};
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  margin: ${({ customMargin }) => !!customMargin && customMargin};
  @media only screen and (max-width: 767px) {
    font-size: 10px;
  }
`

export const StyledReskinContainer = styled('div')`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.gray.mediumlight};

  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  padding: 16px;
  gap: ${({ fromHome, approvalStatus }) =>
    fromHome && !approvalStatus ? '16px' : fromHome && approvalStatus ? '0px' : '5px'};
  @media only screen and (max-width: 767px) {
  }
`
export const StylesReskinMsg = styled('div')`
  color: ${({ theme }) => theme.error.base};
  font-size: 12px;
  margin-top: 8px;
  font-style: italic;
`

export const StyledActionButtons = styled('div')`
  margin-top: 8px;
  position: absolute;
  bottom: 16px;
  @media only screen and (max-width: 769px) {
    position: inherit;
  }
`

export const StyledImageWrapper = styled('div')`
  background-color: ${({ theme }) => theme.gray.gray2};
  height: ${({ fromHome }) => (fromHome ? '120px' : '184px')};
  width: ${({ customWebWidth }) => customWebWidth || '343px'};
  position: relative;
  border-radius: 24px 24px 0 0;
  text-align: center;
  color: ${({ theme }) => theme.gray.gray1};
  svg {
    position: absolute;

    transform: translate(-50%, -50%);
    top: 50%;
  }
  @media only screen and (max-width: 769px) {
    height: ${({ fixedHeight }) => fixedHeight || '96px'};
    width: ${({ customMediaWidth }) => customMediaWidth || '96px'};
    border-radius: ${({ customBorderRadius }) => customBorderRadius || '16px'};
  }
`

export const StyledClassifiedReskinHeader = styled('div')`
  font-size: ${({ fromHome }) => (fromHome ? '13px' : '16px')};
  word-break: break-all;
  word-wrap: break-word;
  text-wrap: balance;
  font-weight: 700;
  color: ${({ theme }) => theme.reskinMenu.active_color};

  line-height: 1.4em;
  display: flex;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  width: 100%;

  @media only screen and (max-width: 769px) {
    font-size: 16px;
  }
`

export const StyledIconSpan = styled('span')`
  color: ${({ isActive, theme }) =>
    isActive ? theme.tabSlider.active_color : theme.tabSlider.inactive_color};
  @media only screen and (min-width: 1024px) {
    margin-right: 4px;
  }
`
export const StyledTabHeaderAndIcon = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const StyledTabForTabReskinSlider = styled('ul')`
  height: 37px;
  width: fit-content;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  list-style: none;
  @media only screen and (min-width: 1024px) {
    margin: 0;
  }

  justify-content: space-around;
  @media only screen and (max-width: 768px) {
    height: 100%;
  }
`

export const StyledTabSliderForTabReskinLi = styled('li')`
  margin-top: -6px;
  width: max-content;
  display: flex;
  padding: 8px 16px 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 40px;
  border: ${({ isActive, theme }) =>
    isActive
      ? `0.33px solid ${theme.tabSlider.reskin_active_background}`
      : 'none'};

  /* Button Highlight & shadow */
  box-shadow: ${({ isActive }) =>
    isActive
      ? `0.75px 0.5px 2px 0px rgba(255, 255, 255, 0.08) inset, 1px 1px 4px 0px rgba(118, 118, 118, 0.06)`
      : 'none'};
  background: ${({ theme, isActive }) =>
    isActive && theme.tabSlider.reskin_active_background};
`

export const StyledNavSliderForTabReskinLink = styled(NavLink)`
  color: ${({ theme }) => theme.tabSlider.inactive_color};
  text-decoration: none;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  display: flex;
  line-height: 16px;
  letter-spacing: 0.25px;
  &.active {
    color: ${({ theme }) => theme.tabSlider.active_color};
    font-weight: 700 !important;
  }

  ::before {
    ${({ hasActiveDot, theme }) =>
      hasActiveDot &&
      `
        content: '.';
        color: ${theme.system_red.color};
        font-weight: bold;
        font-size: xx-large;
        position: absolute;
        margin: -10px 0 0 -12px;
    `}
  }
`

export const StyledTabSliderDiv = styled('div')`
  @media screen and (max-width: 768px) {
    white-space: nowrap;
    position: relative;
    ::after {
      position: absolute;
      top: 0;
      right: 0;
      width: 80px;
      height: 100%;
      content: '';

      pointer-events: none;
    }
  }
`
export const StyledTabSliderGradientDiv = styled('div')`
  @media screen and (max-width: 768px) {
    position: absolute;
    width: 53px;
    height: 43px;
    top: 0;
    right: 0;
    background: ${({ isScrollbarPresent, theme }) =>
      isScrollbarPresent
        ? 'linear-gradient(to right, rgba(1, 1, 1, 0), rgba(1, 1, 1, 0.2))'
        : theme.backgroundColor.white};
    pointer-events: none;
    z-index: 1;
    opacity: ${({ isScrollbarPresent }) => isScrollbarPresent && '0.3'};
  }
`

export const StyledTabSliderUlParentDiv = styled('div')`
  @media screen and (max-width: 768px) {
    overflow-x: scroll;
    overflow-y: hidden;
  }
`
export const StyledMobileAlertCloseBtnDiv = styled('div')`
  position: sticky;
  bottom: 40px;
  width: 100%;
  text-align: center;
  button {
    background-color: ${({ theme }) =>
      theme.mode.isDark && theme.reskinMenu.aside_bar_color};
    color: ${({ theme }) => theme.mode.isDark && theme.reskinMenu.active_color};
  }
`
export const StyledBellNotificationWrapper = styled('a')`
  margin-right: 14px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 8px;
  isolation: isolate;
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.mode.card_border_radius};

  &.isActive {
    background-color: ${({ theme }) =>
      theme.notificationBell.openPanelBackground};
    box-shadow:
      1px 1px 4px rgba(118, 118, 118, 0.06),
      inset 0.75px 0.5px 2px rgba(255, 255, 255, 0.08);
  }
`
export const StyledNotificationIndicatorBadge = styled('span')`
  position: absolute;
  width: 12px;
  height: 12px;
  top: 4px;
  left: 23px;
  background: ${({ theme }) => theme.notificationBell.notificationDot};
  border-radius: 50%;
`
// Start of Styles AutoPaymentStatus.jsx

export const StyledAutoPaymentStatusFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const StyledAutoPaymentStatusFooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  svg {
    margin-left: 8px;
  }

  @media only screen and (max-width: 480px) {
    font-size: 15px;
  }
`

export const StatusLabel = styled.span`
  color: ${({ theme }) => theme.text.dark};
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 106.667% */
  letter-spacing: 0.25px;
`

export const AutoPaymentStatusRoutesLinkWrapper = styled.span`
  a {
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    text-decoration: none;
    color: ${({ theme }) =>
      getEmbeddedViewFlag() ? theme.primary.base : theme.system_blue.color};
  }
`

export const StyledTabTitle = styled('div')`
  @media only screen and (max-width: 1088px) {
    display: ${({ isFromHome }) => isFromHome && 'none'};
  }
`
export const StyledButton = styled('button')`
  background: none;
  border: none;
  color: ${({ theme }) => theme.blue.system_blue};
  font-size: 11px;

  ${underlineFocus}
`

export const StyledLoginPrivacyButton = css`
  cursor: pointer;
  display: inline-block;
  font-family: 'Inter', sans-serif;
  padding: 0;

  &:first-child {
    margin-right: 8px;
    position: relative;

    &::after {
      content: '';
      width: 1px;
      height: 12px;
      background: ${({ theme }) => theme.secondary.base};
      pointer-events: none;
      position: absolute;
      top: 50%;
      right: -8px;
      transform: translateY(-50%);
    }
  }

  &:last-child {
    margin-left: 8px;
  }
`

export const StyledPrivacyButton = css`
  width: 100%;
  display: block;
  margin-top: 16px;
`
export const ModStyledContent = styled(StyledContent)`
  max-height: 100%;
  overflow-y: auto;
  padding: 16px;
  position: relative;
  font-weight: 400;
  font-style: ${(props) => props.fontStyle || 'italic'};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  
  /* Apply accent color to terms and privacy page text */
  ${({ isTermsPage, isPrivacyPage, theme }) => (isTermsPage || isPrivacyPage) && `
    color: ${theme.text?.sidebar_accent};
    
    /* Apply accent color to all text elements within content */
    p, div, span, li, h1, h2, h3, h4, h5, h6 {
      color: ${theme.text?.sidebar_accent};
    }
    
    /* Apply accent color to links within content */
    a {
      color: ${theme.text?.sidebar_accent};
      text-decoration: underline;
    }
  `}

  @media only screen and (max-width: 768px) {
    max-height: 70vh;
  }
`
export const StyledPdfIframe = styled('iframe')`
  width: 100%;
  height: 100vh;
`
// End of Styles AutoPaymentStatus.jsx

export const StyledDefaultTag = styled('button')`
  margin-top: 8px;
  width: max-content;
  align-items: center;
  border-radius: 40px;
  background: ${({ theme }) => theme.notificationBell.openPanelBackground};
  pointer-events: none;
  border: none;
  padding: 4px 8px;
  font-family: Inter;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.gray.dark};
  display: block;
`